import { ReactNode } from "react";
import "./Modal.css";
import "./ModalWindow.css";
import { BackgroundEnum } from "../Enums/ThemeEnums";

/**
 * Function component to view modal window
 */
export const ModalWindow: React.FC<{
  children: ReactNode;
  width?: string;
  height?: string;
}> = ({ children, width = "auto", height = "auto" }) => {
  return (
    <>
      <div className="modal modal--window">
        <div
          className="modal--fill"
          style={{
            width: width,
            background: BackgroundEnum.dust,
            height: height,
            overflow: "auto",
          }}
        >
          <div className="modal--body">{children}</div>
        </div>
      </div>
    </>
  );
};
